import React from 'react';

const TecnoBot = () => {
  return null;
};

export default TecnoBot;